import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutGrid, Building2, Radio, Archive, Truck, Settings as SettingsIcon, LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import ConfirmDialog from "@/components/common/ConfirmDialog";

const NAV = [
  { to: "/", label: "Platform overview", icon: LayoutGrid, testid: "sa-nav-overview" },
  { to: "/tenants", label: "Dealers", icon: Building2, testid: "sa-nav-tenants" },
  { to: "/devices", label: "All devices", icon: Radio, testid: "sa-nav-devices" },
  { to: "/history", label: "All history", icon: Archive, testid: "sa-nav-history" },
  { to: "/orders", label: "Orders", icon: Truck, testid: "sa-nav-orders" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testid: "sa-nav-settings" },
];

export default function SuperAdminShell() {
  const { user, logout } = useAuth();
  const [confirmLogout, setConfirmLogout] = useState(false);

  return (
    <div className="h-full flex bg-kl-black text-white" data-testid="super-admin-shell">
      <aside className="w-[240px] shrink-0 border-r border-kl-line flex flex-col">
        <div className="h-14 flex items-center gap-2 px-6 border-b border-kl-line">
          <ShieldCheck size={15} className="text-kl-green" />
          <span className="font-display font-semibold tracking-[0.3em] text-xs">KYRALINK · ADMIN</span>
        </div>
        <nav className="flex-1 py-6">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink key={to} to={to} end={to === "/"} data-testid={testid}
              className={({ isActive }) => `group flex items-center gap-3 px-6 h-11 text-sm border-l-2 transition-colors duration-150 ${isActive ? "border-kl-green text-white bg-kl-surface" : "border-transparent text-kl-muted hover:text-white hover:bg-kl-surface"}`}>
              <Icon size={16} strokeWidth={1.75} />
              <span className="font-body">{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-kl-line p-5">
          <p className="kl-label-dark">Signed in · super admin</p>
          <div className="flex items-center justify-between pt-2">
            <div className="min-w-0">
              <div className="text-sm truncate" data-testid="sa-user-name">{user?.name}</div>
              <div className="text-xs text-kl-muted truncate">{user?.email}</div>
            </div>
            <button onClick={() => setConfirmLogout(true)} data-testid="sa-logout-button" title="Sign out" className="p-2 text-kl-muted hover:text-white hover:bg-kl-surface transition-colors duration-150 kl-focus"><LogOut size={16} /></button>
          </div>
        </div>
      </aside>

      <main className="flex-1 min-w-0 overflow-hidden bg-white text-kl-black">
        <Outlet />
      </main>

      <ConfirmDialog
        open={confirmLogout}
        onOpenChange={setConfirmLogout}
        title="Sign out?"
        description="You'll need to log back in with the super admin credentials."
        confirmLabel="Sign out"
        onConfirm={() => { setConfirmLogout(false); logout(); }}
      />
    </div>
  );
}
